import React, { Component } from 'react'
import {withRouter} from 'react-router-dom'
import CustomerInfoForm from '../components/Customer/CustomerInfoForm';
import CustomerService from '../services/WebCustomerService';

const styles = {
    title: {
        paddingLeft: '1rem'
    }, 
    error: {
        color: 'red',
        paddingLeft: '1rem'
    }
};

class CreateCustomerPage extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            customer: {},
            errors: []
        }
    }

    onCustomerCreate(customer) {                
        CustomerService.createCustomer(customer, (error, customerId) => {
            if (error) {
                window.scrollTo(0, 0);
                this.setState({ errors: [error]})
            } else {
                this.setState({ errors: [], customer: { ...customer } });
                this.props.history.push({ pathname:`/customer/${customerId}/edit`});            
            }
        });
    }

    render() {
        const { customer, errors } = this.state;
        return (
            <div className="page-content">
                <h2 style={styles.title}>Create Customer</h2>
                {errors.length > 0 ? errors.map(e => (<div className="error-message" style={styles.error}>{e}</div>)) : null}
                <CustomerInfoForm
                    customer={customer}
                    onSave={(customer) => this.onCustomerCreate(customer)}
                    onCancel={() => this.props.history.push({pathname:`/dashboard`})}
                />
            </div>
        );
    }

}

export default withRouter(CreateCustomerPage);
